export default "__VITE_ASSET__OKh7U0hd__"